module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"intro":"Please select the questionnaire you would like to complete.","imprint":"Imprint","privacy-policy":"Privacy Policy","instructions":"Instructions"},"de":{"intro":"Bitte wähle den Fragebogen aus, den du bearbeiten möchtest.","imprint":"Impressum","privacy-policy":"Datenschutz","instructions":"Anleitung"}}')
  delete Component.options._Ctor
}
